webpackJsonp([8,9],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(202),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	youtubeThumbUrl: function youtubeThumbUrl(videoID) {
		return 'https://i1.ytimg.com/vi/' + videoID + '/hqdefault.jpg';
	},
	youtubeEmbedIframeUrl: function youtubeEmbedIframeUrl(videoID) {
		return 'https://www.youtube-nocookie.com/embed/' + videoID + '?rel=0&amp;showinfo=0';
	}
});

/***/ }),

/***/ 112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_vue_interaction_observer__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_youtubeLinks__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'videoplayer',
	data: function data() {
		return {
			msg: ''
		};
	},

	props: {
		videoID: {
			default: ''
		},
		previewType: {
			default: 'video'
		},
		shadow: {
			default: true
		},
		vote: {
			default: true
		},
		detail: {
			default: false
		}
	},
	computed: {
		imgYTalt: function imgYTalt() {
			if (this.videoID) {
				return "immagine per il video su youtube all'indirizzo https://www.youtube.com/watch?v=" + this.videoID;
			}
			return '';
		},
		youtubeThumb: function youtubeThumb() {
			if (this.msg == "Intersected") {
				if (this.videoID) {
					return __WEBPACK_IMPORTED_MODULE_1__lib_youtubeLinks__["a" /* default */].youtubeThumbUrl(this.videoID);
					// return 'https://img.youtube.com/vi/' + this.videoID + '/hqdefault.jpg'
				}
			}
			return '';
		},
		linkToDetail: function linkToDetail() {
			if (this.videoID) {
				return '/detail/' + this.videoID;
			}
			return '';
		},
		youtubeEmbedIframeUrl: function youtubeEmbedIframeUrl() {
			if (this.videoID) {
				return __WEBPACK_IMPORTED_MODULE_1__lib_youtubeLinks__["a" /* default */].youtubeEmbedIframeUrl(this.videoID);
				// return 'https://www.youtube-nocookie.com/embed/' + this.videoID + '?rel=0&amp;showinfo=0'
			}
			return '';
		},
		votes: function votes() {
			return this.$root.votes;
		},
		votesLabel: function votesLabel() {
			if (this.videoID) {
				return this.votes + " voti per il video su youtube all'indirizzo https://www.youtube.com/watch?v=" + this.videoID;
			}
		},
		contStyle: function contStyle() {
			var style = "videoPlayer gdr-card";
			if (this.shadow) {
				style = style + " shadow";
			} else {}
			return style;
		},
		online: function online() {
			if (navigator.onLine) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		voteUp: function voteUp() {
			this.$root.voteUp(this.videoID);
		},
		voteDown: function voteDown() {
			this.$root.voteDown(this.videoID);
		}
	},
	components: {
		Intersect: __WEBPACK_IMPORTED_MODULE_0__lib_vue_interaction_observer__["a" /* default */]
	},
	beforeMount: function beforeMount() {
		if (this.previewType == 'video') {
			this.$root.subVotesForVideo(this.videoID);
		}
	},
	beforeDestroy: function beforeDestroy() {
		if (this.previewType == 'video') {
			this.$root.unsubVotesForVideo(this.videoID);
		}
	}

});

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


var warn = function warn(msg) {
	if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.silent) {
		console.warn(msg);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'intersect',
	abstract: true,
	props: {
		threshold: {
			type: Array,
			required: false,
			default: function _default() {
				return [0, 0.2];
			}
		},
		root: {
			type: HTMLElement,
			required: false,
			default: function _default() {
				return null;
			}
		},
		rootMargin: {
			type: String,
			required: false,
			default: function _default() {
				return '0px 0px 0px 0px';
			}
		}
	},
	created: function created() {
		var _this = this;

		if (IntersectionObserver) {
			this.observer = new IntersectionObserver(function (entries) {
				if (!entries[0].isIntersecting) {
					_this.$emit('leave', [entries[0]]);
				} else {
					_this.$emit('enter', [entries[0]]);
				}

				_this.$emit('change', [entries[0]]);
			}, {
				threshold: this.threshold,
				root: this.root,
				rootMargin: this.rootMargin
			});
		} else {
			this.$emit('enter', [entries[0]]);
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.$nextTick(function () {
			if (_this2.$slots.default && _this2.$slots.default.length > 1) {
				warn('[VueIntersect] You may only wrap one element in a <intersect> component.');
			} else if (!_this2.$slots.default || _this2.$slots.default.length < 1) {
				warn('[VueIntersect] You must have one child inside a <intersect> component.');
				return;
			}
			if (IntersectionObserver) {
				_this2.observer.observe(_this2.$slots.default[0].elm);
			}
		});
	},
	destroyed: function destroyed() {
		if (IntersectionObserver) {
			this.observer.disconnect();
		}
	},
	render: function render() {
		return this.$slots.default ? this.$slots.default[0] : null;
	}
});

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(true);
// imports


// module
exports.push([module.i, ".videoPlayer{background-color:#fff;margin-bottom:25px}.videoPlayer.shadow{-webkit-box-shadow:0 3px 15px rgba(0,0,0,.31);box-shadow:0 3px 15px rgba(0,0,0,.31)}.videoPlayer.shadow:hover{-webkit-box-shadow:0 3px 15px rgba(0,0,0,.6);box-shadow:0 3px 15px rgba(0,0,0,.6)}.videoPlayer .cont169{padding-bottom:56.25%;background-color:#000;display:block;position:relative}.videoPlayer .cont169 iframe{position:absolute;width:100%!important;height:100%!important;top:0;left:0}.videoPlayer .cont169 .imageCont{position:absolute;height:100%!important;top:0;left:0;height:100%;width:100%}.videoPlayer .cont169 .imageCont .youtubeThumb{display:block;margin-left:auto;margin-right:auto;height:100%}.videoPlayer .voteCont{display:block;display:-webkit-box;display:-ms-flexbox;display:flex;padding-left:15px;padding-right:15px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:52px}.videoPlayer .voteCont .voteUp{background:#fff;border:none!important;padding:5px;margin:5px;font-size:18px;padding-left:10px;padding-right:10px;cursor:pointer}.videoPlayer .voteCont .voteUp:hover{color:green;background:rgba(0,0,0,.15)}.videoPlayer .voteCont .voteDown{background:#fff;border:none!important;padding:5px;margin:5px;cursor:pointer;font-size:18px;padding-left:10px;padding-right:10px}.videoPlayer .voteCont .voteDown:hover{color:green;background:rgba(0,0,0,.15)}", "", {"version":3,"sources":["/home/matteo/development/garadirutti/pwa-gdr/src/components/videoPlayer.vue"],"names":[],"mappings":"AACA,aACE,sBAAwB,AACxB,kBAAoB,CACrB,AACD,oBACE,8CAAmD,AAC3C,qCAA2C,CACpD,AACD,0BACE,6CAAkD,AAC1C,oCAA0C,CACnD,AACD,sBACE,sBAA6B,AAC7B,sBAAwB,AACxB,cAAe,AACf,iBAAmB,CACpB,AACD,6BACE,kBAAmB,AACnB,qBAAuB,AACvB,sBAAwB,AACxB,MAAO,AACP,MAAQ,CACT,AACD,iCACE,kBAAmB,AACnB,sBAAwB,AACxB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,UAAY,CACb,AACD,+CACE,cAAe,AACf,iBAAkB,AAClB,kBAAmB,AACnB,WAAa,CACd,AACD,uBACE,cAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,kBAAmB,AACnB,mBAAoB,AACpB,8BAA+B,AACvB,sBAAuB,AAC/B,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,qBAAsB,AAClB,iBAAkB,AACtB,qBAAsB,AAClB,kBAAmB,AACf,yBAA0B,AAClC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAkB,CACnB,AACD,+BACE,gBAAkB,AAClB,sBAAwB,AACxB,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,mBAAoB,AACpB,cAAgB,CACjB,AACD,qCACE,YAAa,AACb,0BAAgC,CACjC,AACD,iCACE,gBAAkB,AAClB,sBAAwB,AACxB,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uCACE,YAAa,AACb,0BAAgC,CACjC","file":"videoPlayer.vue","sourcesContent":["\n.videoPlayer {\n  background-color: white;\n  margin-bottom: 25px;\n}\n.videoPlayer.shadow {\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);\n}\n.videoPlayer.shadow:hover {\n  -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.6);\n          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.6);\n}\n.videoPlayer .cont169 {\n  padding-bottom: calc(56.25%);\n  background-color: black;\n  display: block;\n  position: relative;\n}\n.videoPlayer .cont169 iframe {\n  position: absolute;\n  width: 100% !important;\n  height: 100% !important;\n  top: 0;\n  left: 0;\n}\n.videoPlayer .cont169 .imageCont {\n  position: absolute;\n  height: 100% !important;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n.videoPlayer .cont169 .imageCont .youtubeThumb {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n}\n.videoPlayer .voteCont {\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 15px;\n  padding-right: 15px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  line-height: 52px;\n}\n.videoPlayer .voteCont .voteUp {\n  background: white;\n  border: none !important;\n  padding: 5px;\n  margin: 5px;\n  font-size: 18px;\n  padding-left: 10px;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.videoPlayer .voteCont .voteUp:hover {\n  color: green;\n  background: rgba(0, 0, 0, 0.15);\n}\n.videoPlayer .voteCont .voteDown {\n  background: white;\n  border: none !important;\n  padding: 5px;\n  margin: 5px;\n  cursor: pointer;\n  font-size: 18px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.videoPlayer .voteCont .voteDown:hover {\n  color: green;\n  background: rgba(0, 0, 0, 0.15);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("06e6eef1", content, true, {});

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: _vm.contStyle
  }, [_c('div', {
    staticClass: "cont169"
  }, [(_vm.previewType == 'image') ? _c('div', {
    staticClass: "imageCont"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkToDetail
    }
  }, [_c('intersect', {
    on: {
      "enter": function($event) {
        _vm.msg = 'Intersected'
      },
      "leave": function($event) {
        _vm.msg = 'Not intersected'
      }
    }
  }, [_c('img', {
    staticClass: "youtubeThumb",
    attrs: {
      "src": _vm.youtubeThumb,
      "alt": _vm.imgYTalt
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.previewType == 'video') ? _c('div', [(_vm.online) ? _c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.youtubeEmbedIframeUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.online) ? _c('div', {
    staticClass: "imageCont"
  }, [_c('img', {
    staticClass: "youtubeThumb",
    attrs: {
      "src": _vm.youtubeThumb,
      "alt": _vm.imgYTalt
    }
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.vote) ? _c('div', {
    staticClass: "voteCont"
  }, [(_vm.online) ? _c('div', [(_vm.previewType == 'video') ? _c('span', {
    attrs: {
      "aria-label": _vm.votesLabel
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.votes) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "voteUp",
    attrs: {
      "aria-label": "vota a favore"
    },
    on: {
      "click": _vm.voteUp
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-thumbs-up"
  })]), _vm._v(" "), _c('button', {
    staticClass: "voteDown",
    attrs: {
      "aria-label": "vota contro"
    },
    on: {
      "click": _vm.voteDown
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-thumbs-down"
  })])]) : _vm._e(), _vm._v(" "), (!_vm.online) ? _c('div', [_vm._v("\n\t\t\tSei offline, non puoi vedere il video o votare\n\t\t")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.bcc3202782a40875028c.js